import { FEEDBACK_FORM_URL } from '../utils/support';
import ExternalArrowIcon from './ExternalArrowIcon';
import styles from './FeedbackButton.module.css';

const MegaphoneIcon = () => (
  <svg
    aria-hidden="true"
    className={styles.icon}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 11v2a1 1 0 001 1h2l5 4V6L6 10H4a1 1 0 00-1 1z" />
    <path d="M15 8.5a4 4 0 010 7" />
    <path d="M18 6a7.5 7.5 0 010 12" />
  </svg>
);

interface Props {
  /** Fades the pill out while the retrieved-sources panel covers that corner. */
  contextPanelOpen?: boolean;
}

/**
 * Feedback about the app rather than about one answer, which is what the per-message
 * thumbs already cover. Renders nothing when no form is configured.
 */
export default function FeedbackButton({ contextPanelOpen = false }: Props) {
  if (!FEEDBACK_FORM_URL) return null;

  return (
    <a
      className={`${styles.button} ${contextPanelOpen ? styles.hidden : ''}`}
      href={FEEDBACK_FORM_URL}
      target="_blank"
      rel="noopener noreferrer"
      title="Tell us what to improve (opens a short form in a new tab)"
    >
      <MegaphoneIcon />
      Help us improve
      <ExternalArrowIcon className={styles.arrow} />
    </a>
  );
}
